const KeyIcon = ({
  scale,
  color,
  style,
}: {
  scale?: number;
  color?: string;
  style?: React.CSSProperties;
}) => {
  let c = "#6B7888";
  if (color) c = color;
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})` }}
    >
      <g clipPath="url(#clip0_536_5858)">
        <path
          d="M18.4625 7.06542C18.4625 7.83862 17.8357 8.46542 17.0625 8.46542C16.2893 8.46542 15.6625 7.83862 15.6625 7.06542C15.6625 6.29223 16.2893 5.66543 17.0625 5.66543C17.8357 5.66543 18.4625 6.29223 18.4625 7.06542Z"
          fill={c}
          stroke="#FEFEFE"
          strokeWidth="0.2"
        />
        <path
          d="M7.81813 9.3802L7.81812 9.38019C7.21196 8.01696 7.51795 6.39 8.58001 5.33296L12.2615 1.66876C13.2812 0.6538 14.809 0.329888 16.1534 0.843699C17.4042 1.32179 19.2099 2.20724 20.7214 3.71175L20.7919 3.64087L20.7214 3.71175C22.2384 5.22155 23.1501 7.04681 23.648 8.31462C24.1782 9.66485 23.8563 11.1987 22.8278 12.2224L19.1019 15.9308C18.0492 16.9785 16.4805 17.2861 15.1048 16.7138L15.0664 16.8061L15.1048 16.7138C14.4333 16.4345 13.7825 16.1025 13.1705 15.7268C12.7763 15.4849 12.6529 14.9692 12.8948 14.5749C13.1368 14.1807 13.6525 14.0573 14.0467 14.2992C14.5846 14.6294 15.1571 14.9215 15.7481 15.1673C16.496 15.4783 17.3488 15.3123 17.9203 14.7437L17.8497 14.6728L17.9203 14.7437L21.6462 11.0352C22.2011 10.4829 22.375 9.65526 22.0889 8.92682L21.9959 8.96337L22.0889 8.92682C21.6514 7.8126 20.8536 6.20645 19.5399 4.8989C18.234 3.59909 16.6509 2.827 15.5555 2.40831L15.5555 2.40831C14.8257 2.12943 13.9967 2.30504 13.4431 2.8559L13.5137 2.92678L13.4431 2.85591L9.76173 6.52007C9.18876 7.09037 9.02239 7.96568 9.34874 8.69964C9.61407 9.29648 9.91447 9.87249 10.2416 10.4117C10.4418 10.7416 10.3906 11.1655 10.1178 11.4384L1.80428 19.7518L1.77499 19.7811V19.8225V22.6217V22.7217H1.87499H4.12498H4.22498V22.6217V20.9342C4.22498 20.4717 4.59993 20.0967 5.06248 20.0967L6.74998 20.0967L6.84997 20.0967V19.9967V18.3092C6.84997 17.8467 7.22492 17.4717 7.68747 17.4717H10.3125C10.775 17.4717 11.15 17.8467 11.15 18.3092C11.15 18.7718 10.775 19.1467 10.3125 19.1467H8.62497H8.52497V19.2467V20.9342C8.52497 21.3967 8.15002 21.7717 7.68747 21.7717L5.99997 21.7717L5.89998 21.7717V21.8717V23.5592C5.89998 24.0218 5.52503 24.3967 5.06248 24.3967H0.937496C0.474946 24.3967 0.1 24.0218 0.1 23.5592V19.4342C0.1 19.2121 0.188231 18.9991 0.345303 18.842L8.42535 10.762L8.47831 10.709L8.44238 10.6433C8.21918 10.235 8.01025 9.81236 7.81813 9.3802Z"
          fill={c}
          stroke="#FEFEFE"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_536_5858">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KeyIcon;
